// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { MenuAction, MenuActionT, verifyMenuAction } from "./menu-action";

/**
 * A menu page node — recursive via sub_pages.
 */
export class MenuPage implements flatbuffers.IUnpackableObject<MenuPageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MenuPage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMenuPage(bb: flatbuffers.ByteBuffer, obj?: MenuPage): MenuPage {
    return (obj || new MenuPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMenuPage(bb: flatbuffers.ByteBuffer, obj?: MenuPage): MenuPage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MenuPage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  offline(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  treeKey(): string | null;
  treeKey(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  treeKey(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  actions(index: number, obj?: MenuAction): MenuAction | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? (obj || new MenuAction()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  actionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  subPages(index: number, obj?: MenuPage): MenuPage | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? (obj || new MenuPage()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  subPagesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  locked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startMenuPage(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, nameOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +true);
  }

  static addOffline(builder: flatbuffers.Builder, offline: boolean) {
    builder.addFieldInt8(2, +offline, +true);
  }

  static addTreeKey(builder: flatbuffers.Builder, treeKeyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, treeKeyOffset, 0);
  }

  static addActions(builder: flatbuffers.Builder, actionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, actionsOffset, 0);
  }

  static createActionsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startActionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addSubPages(builder: flatbuffers.Builder, subPagesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, subPagesOffset, 0);
  }

  static createSubPagesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startSubPagesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, descriptionOffset, 0);
  }

  static addLocked(builder: flatbuffers.Builder, locked: boolean) {
    builder.addFieldInt8(7, +locked, +false);
  }

  static endMenuPage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // name
    return offset;
  }

  static createMenuPage(
    builder: flatbuffers.Builder,
    nameOffset: flatbuffers.Offset,
    active: boolean,
    offline: boolean,
    treeKeyOffset: flatbuffers.Offset,
    actionsOffset: flatbuffers.Offset,
    subPagesOffset: flatbuffers.Offset,
    descriptionOffset: flatbuffers.Offset,
    locked: boolean,
  ): flatbuffers.Offset {
    MenuPage.startMenuPage(builder);
    MenuPage.addName(builder, nameOffset);
    MenuPage.addActive(builder, active);
    MenuPage.addOffline(builder, offline);
    MenuPage.addTreeKey(builder, treeKeyOffset);
    MenuPage.addActions(builder, actionsOffset);
    MenuPage.addSubPages(builder, subPagesOffset);
    MenuPage.addDescription(builder, descriptionOffset);
    MenuPage.addLocked(builder, locked);
    return MenuPage.endMenuPage(builder);
  }

  unpack(): MenuPageT {
    return new MenuPageT(
      this.name(),
      this.active(),
      this.offline(),
      this.treeKey(),
      this.bb!.createObjList<MenuAction, MenuActionT>(
        this.actions.bind(this),
        this.actionsLength(),
      ),
      this.bb!.createObjList<MenuPage, MenuPageT>(this.subPages.bind(this), this.subPagesLength()),
      this.description(),
      this.locked(),
    );
  }

  unpackTo(_o: MenuPageT): void {
    _o.name = this.name();
    _o.active = this.active();
    _o.offline = this.offline();
    _o.treeKey = this.treeKey();
    _o.actions = this.bb!.createObjList<MenuAction, MenuActionT>(
      this.actions.bind(this),
      this.actionsLength(),
    );
    _o.subPages = this.bb!.createObjList<MenuPage, MenuPageT>(
      this.subPages.bind(this),
      this.subPagesLength(),
    );
    _o.description = this.description();
    _o.locked = this.locked();
  }

  unpackFields(...fields: string[]): MenuPageT {
    const t = new MenuPageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("offline")) {
      t.offline = this.offline();
    }
    if (fieldSet.has("tree_key")) {
      t.treeKey = this.treeKey();
    }
    if (fieldSet.has("actions")) {
      t.actions = this.bb!.createObjList<MenuAction, MenuActionT>(
        this.actions.bind(this),
        this.actionsLength(),
      );
    }
    if (fieldSet.has("sub_pages")) {
      t.subPages = this.bb!.createObjList<MenuPage, MenuPageT>(
        this.subPages.bind(this),
        this.subPagesLength(),
      );
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("locked")) {
      t.locked = this.locked();
    }
    return t;
  }
}

export class MenuPageT implements flatbuffers.IGeneratedObject {
  constructor(
    public name: string | Uint8Array | null = null,
    public active: boolean = true,
    public offline: boolean = true,
    public treeKey: string | Uint8Array | null = null,
    public actions: MenuActionT[] = [],
    public subPages: MenuPageT[] = [],
    public description: string | Uint8Array | null = null,
    public locked: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const treeKey = this.treeKey !== null ? builder.createString(this.treeKey!) : 0;
    const actions = MenuPage.createActionsVector(
      builder,
      builder.createObjectOffsetList(this.actions),
    );
    const subPages = MenuPage.createSubPagesVector(
      builder,
      builder.createObjectOffsetList(this.subPages),
    );
    const description = this.description !== null ? builder.createString(this.description!) : 0;

    return MenuPage.createMenuPage(
      builder,
      name,
      this.active,
      this.offline,
      treeKey,
      actions,
      subPages,
      description,
      this.locked,
    );
  }

  clone(): MenuPageT {
    const obj = new MenuPageT();
    obj.name = this.name;
    obj.active = this.active;
    obj.offline = this.offline;
    obj.treeKey = this.treeKey;
    obj.actions = this.actions.map((e) => e.clone());
    obj.subPages = this.subPages.map((e) => e.clone());
    obj.description = this.description;
    obj.locked = this.locked;
    return obj;
  }

  equals(other: MenuPageT): boolean {
    if (this.name !== other.name) return false;
    if (this.active !== other.active) return false;
    if (this.offline !== other.offline) return false;
    if (this.treeKey !== other.treeKey) return false;
    if (this.actions.length !== other.actions.length) return false;
    for (let i = 0; i < this.actions.length; i++) {
      const a = this.actions[i];
      const b = other.actions[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.subPages.length !== other.subPages.length) return false;
    for (let i = 0; i < this.subPages.length; i++) {
      const a = this.subPages[i];
      const b = other.subPages[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.description !== other.description) return false;
    if (this.locked !== other.locked) return false;
    return true;
  }
}

export function verifyMenuPage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "name");
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMenuAction);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyMenuPage);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 18, 1);
  } finally {
    verifier.popDepth();
  }
}
